import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { getL3ServiceStatusGroup } from '../../api';
import { DashboardHttpQueryConfig } from '../../config';
import { L3ServiceStatusGroupApiModel } from '../../model';

export const useL3ServiceStatusGroup = (customerId: number | null): UseQueryResult<L3ServiceStatusGroupApiModel[] | null, Error> => {
  const axios = useAuthorizedAxios();
  return useQuery({
    queryKey: [DashboardHttpQueryConfig['GetL3ServiceStatusGroup'].key, customerId],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        return await getL3ServiceStatusGroup(axios, { customerId });
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 5000,
    staleTime: 0,
    structuralSharing: false
  });
};